import { FinancialOverviewInstitution, FinancialOverviewLocation } from '../../types';

interface InstitutionWebsiteMatch {
    aliases: string[];
    location?: Pick<FinancialOverviewLocation, 'city' | 'country' | 'latitude' | 'longitude' | 'region'>;
    website: string;
}

const institutionWebsiteMatches: InstitutionWebsiteMatch[] = [
    {
        aliases: ['diversified trust'],
        location: { city: 'Nashville', country: 'United States', latitude: 36.1627, longitude: -86.7816 },
        website: 'diversifiedtrust.com',
    },
    {
        aliases: ['vaughan nelson'],
        location: { city: 'Houston', country: 'United States', latitude: 29.7604, longitude: -95.3698 },
        website: 'vaughannelson.com',
    },
    {
        aliases: ['cboe vest'],
        location: { city: 'McLean', country: 'United States', latitude: 38.9339, longitude: -77.1773 },
        website: 'cboevest.com',
    },
    {
        aliases: ['truist'],
        location: { city: 'Charlotte', country: 'United States', latitude: 35.2271, longitude: -80.8431 },
        website: 'truist.com',
    },
    {
        aliases: ['sumitomo mitsui trust'],
        location: { city: 'Tokyo', country: 'Japan', latitude: 35.6762, longitude: 139.6503 },
        website: 'smth.jp',
    },
    {
        aliases: ['swedbank'],
        location: { city: 'Stockholm', country: 'Sweden', latitude: 59.3293, longitude: 18.0686 },
        website: 'swedbank.com',
    },
    {
        aliases: ['robeco'],
        location: { city: 'Rotterdam', country: 'Netherlands', latitude: 51.9244, longitude: 4.4777 },
        website: 'robeco.com',
    },
    {
        aliases: ['abrdn'],
        location: { city: 'Edinburgh', country: 'United Kingdom', latitude: 55.9533, longitude: -3.1883 },
        website: 'abrdn.com',
    },
    {
        aliases: ['pictet'],
        location: { city: 'Geneva', country: 'Switzerland', latitude: 46.2044, longitude: 6.1432 },
        website: 'pictet.com',
    },
    {
        aliases: ['ninety one'],
        location: { city: 'London', country: 'United Kingdom', latitude: 51.5072, longitude: -0.1276 },
        website: 'ninetyone.com',
    },
    {
        aliases: ['new york state common retirement'],
        location: { city: 'Albany', country: 'United States', latitude: 42.6526, longitude: -73.7562 },
        website: 'osc.ny.gov',
    },
    {
        aliases: ['parnassus investments'],
        location: { city: 'San Francisco', country: 'United States', latitude: 37.7749, longitude: -122.4194 },
        website: 'parnassus.com',
    },
    {
        aliases: ['alecta'],
        location: { city: 'Stockholm', country: 'Sweden', latitude: 59.3293, longitude: 18.0686 },
        website: 'alecta.se',
    },
    {
        aliases: ['state street', 'ssga'],
        location: { city: 'Boston', country: 'United States', latitude: 42.3601, longitude: -71.0589 },
        website: 'ssga.com',
    },
    {
        aliases: ['geode capital'],
        location: { city: 'Boston', country: 'United States', latitude: 42.3601, longitude: -71.0589 },
        website: 'geodecapital.com',
    },
    {
        aliases: ['dimensional fund advisors'],
        location: { city: 'Austin', country: 'United States', latitude: 30.2672, longitude: -97.7431 },
        website: 'dimensional.com',
    },
    {
        aliases: ['capital research', 'capital group'],
        location: { city: 'Los Angeles', country: 'United States', latitude: 34.0522, longitude: -118.2437 },
        website: 'capitalgroup.com',
    },
    {
        aliases: ['franklin resources', 'franklin templeton'],
        location: { city: 'San Mateo', country: 'United States', latitude: 37.563, longitude: -122.3255 },
        website: 'franklintempleton.com',
    },
    {
        aliases: ['t rowe price'],
        location: { city: 'Baltimore', country: 'United States', latitude: 39.2904, longitude: -76.6122 },
        website: 'troweprice.com',
    },
    {
        aliases: ['northern trust'],
        location: { city: 'Chicago', country: 'United States', latitude: 41.8781, longitude: -87.6298 },
        website: 'northerntrust.com',
    },
    {
        aliases: ['goldman sachs'],
        location: { city: 'New York', country: 'United States', latitude: 40.7128, longitude: -74.006 },
        website: 'goldmansachs.com',
    },
    {
        aliases: ['morgan stanley'],
        location: { city: 'New York', country: 'United States', latitude: 40.7128, longitude: -74.006 },
        website: 'morganstanley.com',
    },
    {
        aliases: ['bank of america'],
        location: { city: 'Charlotte', country: 'United States', latitude: 35.2271, longitude: -80.8431 },
        website: 'bankofamerica.com',
    },
    {
        aliases: ['jp morgan', 'jpmorgan'],
        location: { city: 'New York', country: 'United States', latitude: 40.7128, longitude: -74.006 },
        website: 'jpmorgan.com',
    },
    {
        aliases: ['charles schwab'],
        location: { city: 'Westlake', country: 'United States', latitude: 32.9912, longitude: -97.195 },
        website: 'schwab.com',
    },
    {
        aliases: ['wellington management'],
        location: { city: 'Boston', country: 'United States', latitude: 42.3601, longitude: -71.0589 },
        website: 'wellington.com',
    },
    {
        aliases: ['blackrock'],
        location: { city: 'New York', country: 'United States', latitude: 40.7128, longitude: -74.006 },
        website: 'blackrock.com',
    },
    {
        aliases: ['vanguard'],
        location: { city: 'Malvern', country: 'United States', latitude: 40.0362, longitude: -75.5138 },
        website: 'vanguard.com',
    },
    {
        aliases: ['invesco'],
        location: { city: 'Atlanta', country: 'United States', latitude: 33.749, longitude: -84.388 },
        website: 'invesco.com',
    },
    {
        aliases: ['pimco'],
        location: { city: 'Newport Beach', country: 'United States', latitude: 33.6189, longitude: -117.9298 },
        website: 'pimco.com',
    },
    {
        aliases: ['amundi'],
        location: { city: 'Paris', country: 'France', latitude: 48.8566, longitude: 2.3522 },
        website: 'amundi.com',
    },
    {
        aliases: ['allianz'],
        location: { city: 'Munich', country: 'Germany', latitude: 48.1351, longitude: 11.582 },
        website: 'allianz.com',
    },
    {
        aliases: ['barclays'],
        location: { city: 'London', country: 'United Kingdom', latitude: 51.5072, longitude: -0.1276 },
        website: 'barclays.com',
    },
    {
        aliases: ['deutsche bank'],
        location: { city: 'Frankfurt', country: 'Germany', latitude: 50.1109, longitude: 8.6821 },
        website: 'db.com',
    },
    {
        aliases: ['bnp paribas'],
        location: { city: 'Paris', country: 'France', latitude: 48.8566, longitude: 2.3522 },
        website: 'group.bnpparibas',
    },
    {
        aliases: ['ubs'],
        location: { city: 'Zurich', country: 'Switzerland', latitude: 47.3769, longitude: 8.5417 },
        website: 'ubs.com',
    },
    {
        aliases: ['fmr', 'fidelity'],
        location: { city: 'Boston', country: 'United States', latitude: 42.3601, longitude: -71.0589 },
        website: 'fidelity.com',
    },
    {
        aliases: ['fisher investments'],
        location: { city: 'Camas', country: 'United States', latitude: 45.5871, longitude: -122.3995 },
        website: 'fisherinvestments.com',
    },
    {
        aliases: ['renaissance technologies'],
        location: { city: 'East Setauket', country: 'United States', latitude: 40.9415, longitude: -73.1059 },
        website: 'rentec.com',
    },
    {
        aliases: ['bridgewater associates'],
        location: { city: 'Westport', country: 'United States', latitude: 41.1415, longitude: -73.3579 },
        website: 'bridgewater.com',
    },
    {
        aliases: ['two sigma'],
        location: { city: 'New York', country: 'United States', latitude: 40.7128, longitude: -74.006 },
        website: 'twosigma.com',
    },
    {
        aliases: ['citadel advisors', 'citadel'],
        location: { city: 'Miami', country: 'United States', latitude: 25.7617, longitude: -80.1918 },
        website: 'citadel.com',
    },
];

const normalizeInstitutionName = (value: string) =>
    value
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

const containsAlias = (institutionName: string, alias: string) =>
    ` ${institutionName} `.includes(` ${normalizeInstitutionName(alias)} `);

const resolveInstitutionMatch = (institution: FinancialOverviewInstitution) => {
    const institutionName = normalizeInstitutionName(institution.investorName ?? institution.holder ?? '');

    if (!institutionName) {
        return undefined;
    }

    return institutionWebsiteMatches.find(({ aliases }) =>
        aliases.some((alias) => containsAlias(institutionName, alias)),
    );
};

export const resolveInstitutionWebsite = (institution: FinancialOverviewInstitution): string | undefined => {
    const reportedWebsite = [institution.website, institution.websiteUrl, institution.domain].find(
        (website) => typeof website === 'string' && website.trim().length > 0,
    );

    if (reportedWebsite) {
        return reportedWebsite.trim();
    }

    return resolveInstitutionMatch(institution)?.website;
};

export const resolveInstitutionLocation = (
    institution: FinancialOverviewInstitution,
    index: number,
): FinancialOverviewLocation | undefined => {
    const match = resolveInstitutionMatch(institution);

    if (!match?.location) {
        return undefined;
    }

    const name = institution.investorName ?? institution.holder ?? `Institution ${index + 1}`;

    return {
        ...match.location,
        id: `institutional-holder-${index}`,
        label: 'Top Institutional Holder',
        name,
    };
};
